/**
 * Splits `items` into consecutive chunks of at most `size` elements.
 * Used to keep bulk API calls within the server-side per-request cap.
 */
export function chunk<T>(items: readonly T[], size: number): T[][] {
  if (size <= 0) {
    throw new Error('chunk size must be positive');
  }
  const out: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    out.push(items.slice(i, i + size));
  }
  return out;
}
